import { Icon, Input, makeStyles } from '@rneui/themed'
import { Platform } from 'react-native'
import { PressableOpacity } from './pressable_opacity'

interface Props {
  searchTerm: string
  setSearchTerm: React.Dispatch<React.SetStateAction<string>>
  onPressClear: () => void
  autoFocus?: boolean
}
export default function SearchBar({
  searchTerm,
  setSearchTerm,
  onPressClear,
  autoFocus,
}: Props) {
  const styles = useStyles()
  return (
    <Input
      style={styles.text}
      placeholder="Search"
      onChangeText={setSearchTerm}
      autoFocus={autoFocus}
      value={searchTerm}
      containerStyle={styles.searchInputContainer}
      inputStyle={styles.input}
      inputContainerStyle={styles.searchInput}
      rightIcon={
        <PressableOpacity onPress={onPressClear}>
          <Icon name="close" type="ionicons" />
        </PressableOpacity>
      }
    />
  )
}
const useStyles = makeStyles(theme => ({
  text: {
    fontSize: 14,
    marginRight: 5,
  },
  searchInputContainer: { paddingHorizontal: 0 },
  input: {
    paddingLeft: 5,
    ...(Platform.OS === 'web' && ({ outlineStyle: 'none' } as any)),
  },
  searchInput: {
    borderRadius: 15,
    borderWidth: 1,
    marginTop: 5,
    paddingHorizontal: 5,
    paddingVertical: 3,
    borderBottomWidth: 1,
    ...(Platform.OS === 'web' && ({ outlineStyle: 'none' } as any)),
  },
}))
